import React, {useRef, useState} from 'react';
import {DeleteForever} from '@mui/icons-material';
import '../component.css';

const HOLD_DURATION = 500;

export default function HoldButton({onClick, disabled}) {
    const [holding, setHolding] = useState(false);
    const timerRef = useRef(null);

    const startHold = (e) => {
        if (disabled) return;
        e.preventDefault();
        e.target.setPointerCapture(e.pointerId);
        setHolding(true);
        timerRef.current = setTimeout(() => {
            timerRef.current = null;
            setHolding(false);
            if (onClick) onClick();
        }, HOLD_DURATION);
    };

    const cancelHold = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setHolding(false);
    };

    return (
        <div
            className={'HoldButton' + (disabled ? ' HoldButton--disabled' : '')}
            onPointerDown={startHold}
            onPointerUp={cancelHold}
            onPointerLeave={cancelHold}
            onContextMenu={e => e.preventDefault()}
            style={{touchAction: 'none', WebkitUserSelect: 'none', userSelect: 'none'}}
        >
            <div className={'HoldButton-fill' + (holding ? ' HoldButton-fill--active' : '')}/>
            <DeleteForever style={{position: 'relative', zIndex: 1, fontSize: '24px', color: disabled ? 'rgba(0,0,0,0.2)' : 'rgba(0,0,0,0.54)'}}/>
        </div>
    );
}
